import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { LucideAngularModule, Bot } from 'lucide-angular';
import { ChatbotInteractionService } from '../chatbot-interaction/services/chatbot-interaction.service';
import { ChatbotSelectorBaseComponent } from '../../shared/components/chatbot-selector/chatbot-selector-base.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { SearchInputComponent } from '../../shared/components/search-input/search-input.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { EmptyStateComponent } from '../../shared/components/empty-state/empty-state.component';
import { ChatbotCardGridComponent } from '../../shared/components/chatbot-card-grid/chatbot-card-grid.component';

/**
 * Wrapper component for conversation viewer chatbot selection
 * Shows the same chatbot grid but redirects to conversation viewer
 */
@Component({
  selector: 'app-chatbot-select-wrapper',
  standalone: true,
  imports: [
    LucideAngularModule,
    PageHeaderComponent,
    SearchInputComponent,
    LoadingSpinnerComponent,
    EmptyStateComponent,
    ChatbotCardGridComponent
],
  template: `
    <div class="chatbot-interaction-container">
      <div class="header-section">
        <app-page-header
          title="Visualizador de Conversaciones"
          subtitle="Selecciona un chatbot para explorar sus conversaciones"
        ></app-page-header>
      </div>

      <div class="flex-1 max-w-md mb-8">
        <app-search-input
          [value]="searchQuery"
          (valueChange)="searchQuery = $event"
          placeholder="Buscar chatbot..."
        ></app-search-input>
      </div>

      @if (loading()) {
        <app-loading-spinner message="Cargando chatbots..." [size]="50"></app-loading-spinner>
      } @else if (error()) {
        <app-empty-state
          [title]="error()!"
          message=""
          emoji="⚠️"
        ></app-empty-state>
      } @else {
        <app-chatbot-card-grid
          [chatbots]="filteredChatbots"
          avatarStyle="initial"
          [showCode]="false"
          (selectChatbot)="selectChatbot($event)"
        ></app-chatbot-card-grid>

        @if (filteredChatbots.length === 0) {
          <app-empty-state
            [icon]="Bot"
            title="No se encontró ningún chatbot"
            message="Intenta ajustar tus términos de búsqueda"
          ></app-empty-state>
        }
      }
    </div>
  `,
  styles: [`
    .chatbot-interaction-container {
      padding: 2rem;
      margin: 0 auto;
    }

    .header-section {
      margin-bottom: 2rem;
    }
  `]
})
export class ChatbotSelectWrapperComponent extends ChatbotSelectorBaseComponent {
  readonly Bot = Bot;

  constructor(
    router: Router,
    chatbotService: ChatbotInteractionService
  ) {
    super(router, chatbotService);
    this.redirectPath = '/chatbot/conversations'; // Redirect to conversation viewer    
  }
}
